import React, { useState } from 'react';
import { useAuth } from "@/context/AuthContext";
import BrandUploadLink from "./BrandUploadLink";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { generateUniqueSlug, updateBrandSlug } from "@/services/photoStorage";
import { useToast } from "@/hooks/use-toast";

const UploadLinkSection: React.FC = () => {
  const { brand, setBrand } = useAuth();
  const { toast } = useToast();
  const [isGenerating, setIsGenerating] = useState(false);

  const handleGenerateUploadLink = async () => {
    if (!brand) return;

    setIsGenerating(true);
    try {
      // Generate the upload link using the consistent generateUniqueSlug function
      const uploadLink = generateUniqueSlug(brand.name, brand.id);

      toast({
        title: "Upload Link Generated",
        description: "Your brand now has a unique upload link that you can share with customers.",
      });
    } catch (error) {
      console.error("Error generating upload link:", error);
      toast({
        title: "Error",
        description: "Failed to generate upload link. Please try again.",
        variant: "destructive",
      });
    } finally {
      setIsGenerating(false);
    }
  };

  // Show upload link if brand exists
  if (!brand) {
    return null;
  }

  return (
    <div className="mb-8 space-y-4">
      <BrandUploadLink brand={brand} />
    </div>
  );
};

export default UploadLinkSection;
